import type { IChatHeader } from 'features/Chat/Chat.types'

const sortChatUsers = (a, b) => {
	const fa = a.name.toLowerCase()
	const fb = b.name.toLowerCase()

	if (fa < fb) return -1
	if (fa > fb) return 1
	return 0
}

/**
 * Adds the display `label` and `avatars` to each header, derived from the
 * participants other than the current user.
 *
 * Returns new objects rather than mutating in place. Headers now come from
 * Redux, and writing to them there trips RTK's immutability check in dev.
 */
export const formatChatHeadersByUserId = (chatHeaders: IChatHeader[], userId) => {
	return chatHeaders.map(chatHeader => {
		const chatUsers = [
			chatHeader.senderId,
			...chatHeader.receiverIds.map(receiverId => receiverId.receiverId),
		]
			.filter(user => user && user._id !== userId)
			.sort(sortChatUsers)

		return {
			...chatHeader,
			label: chatUsers.map(user => user.name).join(', '),
			avatars: chatUsers.map(user => ({
				name: user.name,
				// @ts-ignore
				src: user.image,
			})),
		}
	})
}

export default formatChatHeadersByUserId
